// extracted by mini-css-extract-plugin
export default {"shemeBox":"ShemeStyle_shemeBox__RhKd6"};